














































// vendor
import { defineComponent, computed, ref, PropType } from "@vue/composition-api";
// project
import * as DeviceUtils from "@/utils/device";
// local
import { SetupContext, SetupResult } from "../ts/DeviceSetup";

export default defineComponent({
	emits:[
		"done",
	],
	props:{
		context:{
			type:Object as PropType<SetupContext>,
			required:true,
		}
	},
	components:{
	},
	setup(props, context){
		
		const accelerometerEnabled = ref(false);
		const done = () => {
			const r:SetupResult = {
				accelerometerEnabled:accelerometerEnabled.value,
			};
			context.emit("done", r);
		};

		const confirm = async () => {
			accelerometerEnabled.value = await DeviceUtils.hasDeviceOrientation();
			done();
		};

		return {
			confirm,
		};
	}
});

